import React, { useState, useEffect } from 'react';
import { Stack } from 'react-bootstrap';
import { SearchBar } from '../components/SearchBar';
import { FratSummary } from '../components/FratSummary';
import { Review } from '../components/Review';
import { ref, get, child, query, orderByChild, equalTo } from "firebase/database";
import { db } from '../index';
import moment from 'moment';

function CompareCol(props) {
  const [fratInfo, setFratInfo] = useState({});
  const [loadingFrat, setLoadingFrat] = useState(true);

  const [reviews, setReviews] = useState([]);
  const [loadingReviews, setLoadingReviews] = useState(true);

  function update(fratname) {
    const fratList = ref(db, 'frats');
    const reviewList = ref(db, 'reviews');

    const fetchFratData = async (fratname) => {
      console.log("Getting frat data...");
      setLoadingFrat(true);
      get(child(fratList, fratname)).then((snapshot) => {
        if (snapshot.exists()) {
          setFratInfo(snapshot.val());
        } else {
          console.log("No data available");
        }
        setLoadingFrat(false);
      }).catch((error) => {
        console.error(error);
        setLoadingFrat(false);
      });
    }

    const fetchFratReviews = async (fratname) => {
      console.log("Getting reviews...");
      setLoadingReviews(true);
      let qRef = query(reviewList, orderByChild('frat'), equalTo(fratname));
      get(qRef).then((snapshot) => {
          if (snapshot.exists()) {
              let data = snapshot.val();
              //sort by votes + newest
              let sorted = Object.entries(data).sort((review1, review2) => {
                  return moment(review2[1].dateTime, "DD/MM/YYYY HH:mm:ss").valueOf() -
                  moment(review1[1].dateTime, "DD/MM/YYYY HH:mm:ss").valueOf();
              }).sort((review1, review2) => {
                  return review2[1].votes - review1[1].votes;
              })
              setReviews(sorted);
          } else {
              console.log("No data available");
              setReviews([]);
          }
          setLoadingReviews(false);
      }).catch((error) => {
          console.error(error);
          setLoadingReviews(false);
      });
    }

    fetchFratData(fratname);
    fetchFratReviews(fratname);
  }

  useEffect(() => {
    if (props.frat) {
      update(props.frat);
    }
  }, []);

  return (
    <Stack className="col-md-5 mx-4" gap={4}>
      <div className="d-flex justify-content-center">
        <SearchBar handleSelect={update} value={props.frat} />
      </div>
      <FratSummary data={fratInfo} loading={loadingFrat} showInfo="false" />
      {loadingReviews ? (
        <></>
      ) : (
        reviews.slice(0, 3).map(([key, value]) => { //show first 3 reviews
          return (
            <Review
              key={key}
              id={key}
              data={value}
            />
          );
        })
      )}
    </Stack>
  );
}

export { CompareCol };